import { __values } from "tslib";
import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
export function useCurrentRoute(routes) {
    var location = useLocation();
    var matchedRoute = useMemo(function () {
        var e_1, _a;
        try {
            for (var routes_1 = __values(routes), routes_1_1 = routes_1.next(); !routes_1_1.done; routes_1_1 = routes_1.next()) {
                var route = routes_1_1.value;
                var match = matchPath(location.pathname, route);
                if (match) {
                    return match;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (routes_1_1 && !routes_1_1.done && (_a = routes_1.return)) _a.call(routes_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return undefined;
    }, [location.pathname, routes]);
    return matchedRoute;
}
//# sourceMappingURL=useCurrentRoute.js.map